import React, { FunctionComponent, SVGProps } from 'react'

export const IconArrow: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    stroke="#FCFCFC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 13L1 7L7 1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
